// Vendor Libs
import {map} from 'lodash';

// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesFormConfig from '../../config/services-form-config';

export function setExternalNetworkChecked(externalNetworkName, partnerId, checked) {
    return (dispatch) => {
        dispatch({
            type: 'NETWORK_SET_EXTERNAL_NETWORK_CHECKED',
            externalNetworkName,
            partnerId,
            checked,
        });
    };
}

export function setNetwork(networkId, networkName) {
    return (dispatch) => {
        dispatch({
            type: 'NETWORK_SET_NETWORK',
            networkId,
            networkName,
        });
    };
}

export function networkMappingReset() {
    return (dispatch) => {
        dispatch({
            type: 'NETWORK_MAPPING_RESET',
        });
    };
}

export function mapExternalNetworks() {
    return (dispatch, getState) => {
        const {externalNetworks, networkId} = getState().networks;

        return new Promise((resolve) => {
            dispatch({
                type: 'NETWORK_MAP_EXTERNAL_NETWORKS',
                fetching: true,
                mappingComplete: false,
            });

            if (networkId !== null) {
                Promise.all(
                    map(
                        externalNetworks,
                        ({externalNetworkName, partnerId}) =>
                            new Promise((resolve) => {
                                const dispatchFetched = () => {
                                    dispatch({
                                        type: 'NETWORK_FETCH_FULFILLED',
                                        formName: 'mapExternalNetwork',
                                        externalNetworkName,
                                    });
                                    resolve();
                                };
                                const dispatchError = (error) => {
                                    dispatch({
                                        type: 'NETWORK_FETCH_REJECTED',
                                        externalNetworkName,
                                        error,
                                    });
                                    resolve();
                                };
                                const actionParams = {
                                    servicesConfig: servicesFormConfig.mapExternalNetwork,
                                    dispatchFetched,
                                    dispatchError,
                                };

                                actionsServiceCaller(actionParams, {externalNetworkName, partnerId, networkId});
                            })
                    ),
                ).then(() => {
                    dispatch({
                        type: 'NETWORK_FETCH_COMPLETED',
                        fetching: false,
                        mappingComplete: true,
                    });
                    resolve();
                });
            } else {
                resolve();
            }
        });
    };
}
